import {
  isSamePathname,
  targetPathname,
  targetSearch,
  To,
} from '../../../../smartLinks/catalog/song/page/useLeaveGuard';
import { parseReleaseTab, ReleaseTab } from '../releaseTabProps';
import { parseReleaseFocus } from '../releasePageLink';

/**
 * The leave rule of the Releases song page: a target stays on the page only when it opens the same
 * song (`?catalogItemUuid=`) on the same tab. The Theme draft lives in the Overview tab and a tab
 * change unmounts it, so a change of `?tab=` (or `?focus=`, which opens Posts) is a leave too.
 * Another song on the same route is a leave, because the Theme draft belongs to one song. A target
 * with only a hash stays.
 */
export function isSameReleasePage(to: To, catalogItemUuid: string, currentTab: ReleaseTab): boolean {
  if (!isSamePathname(to)) {
    return false;
  }
  const search = targetSearch(to);
  if (targetPathname(to) === '' && search === '') {
    return true;
  }
  const params = new URLSearchParams(search);
  if (params.get('catalogItemUuid') !== catalogItemUuid) {
    return false;
  }
  const targetTab: ReleaseTab =
    parseReleaseFocus(params.get('focus')) !== undefined ? 'posts' : parseReleaseTab(params.get('tab'));
  return targetTab === currentTab;
}
